module.exports = __webpack_public_path__ + "static/media/buy2.86d25b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/buy2.png
// module id = 1221
// module chunks = 0